import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "../lib/track";

export function PageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageview(location.pathname);
  }, [location.pathname]);
  return null;
}
